"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.LinkGroupItem = exports.default = exports.LinkListGroupBlock = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _link = babelHelpers.interopRequireDefault(require("card/link"));

var _linkList = babelHelpers.interopRequireDefault(require("./linkList"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp, _class3, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp2, _class5, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var LinkListGroupBlock =
/*#__PURE__*/
function (_LinkListBlock) {
  babelHelpers.inherits(LinkListGroupBlock, _LinkListBlock);

  function LinkListGroupBlock() {
    babelHelpers.classCallCheck(this, LinkListGroupBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(LinkListGroupBlock).apply(this, arguments));
  }

  return LinkListGroupBlock;
}(_linkList.default);

exports.LinkListGroupBlock = LinkListGroupBlock;
var LinksGroupBlock = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(LinksGroupBlock, _Block);

  function LinksGroupBlock() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, LinksGroupBlock);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(LinksGroupBlock)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "displayMode", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "groups", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "className", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "child_type", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "id", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(LinksGroupBlock, [{
    key: "render",
    value: function render() {
      if (this.displayMode == 'linksGroup' || this.displayMode == 'linkGroup') {
        return babelHelpers.get(babelHelpers.getPrototypeOf(LinksGroupBlock.prototype), "render", this).call(this);
      }

      return _react.default.createElement(LinkListGroupBlock, this.props);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this4 = this;

      return this.groups.map(function (group) {
        return _react.default.createElement(LinkGroupItem, _extends({}, group, {
          className: _this4.className,
          child_type: _this4.child_type,
          blockId: _this4.id,
          attributes: _this4.attributes,
          key: group.id
        }));
      });
    }
  }]);
  return LinksGroupBlock;
}(_base.default), _temp3), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "displayMode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "groups", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "child_type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.default = LinksGroupBlock;
var LinkGroupItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(LinkGroupItem, _Component);

  function LinkGroupItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LinkGroupItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LinkGroupItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "child_type", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "blockId", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(LinkGroupItem, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", _extends({
        className: this.className,
        "data-block-type": this.child_type,
        "data-block-id": this.blockId,
        "data-group-id": this.id
      }, this.attributes), _react.default.createElement("div", {
        className: "link-group"
      }, _react.default.createElement("h1", null, this.title), _react.default.createElement("div", {
        className: "link-group-items"
      }, this.items.map(function (item) {
        return _react.default.createElement(Link, _extends({
          key: item.id
        }, item));
      }))));
    }
  }]);
  return LinkGroupItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "child_type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "blockId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.LinkGroupItem = LinkGroupItem;
var Link = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(Link, _Component2);

  function Link() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, Link);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(Link)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "url", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "openInNewWindow", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "host", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(Link, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("a", {
        className: "link",
        href: this.url,
        target: this.openInNewWindow ? '_blank' : '_self'
      }, _react.default.createElement("div", {
        className: "link-content"
      }, _react.default.createElement("div", {
        className: "link-title"
      }, this.title), _react.default.createElement("div", {
        className: "link-host"
      }, this.host)));
    }
  }]);
  return Link;
}(_react.Component), _temp2), (_descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "url", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "openInNewWindow", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "host", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.Link = Link;